/* eslint-disable radix */
import React, { useState } from 'react';
import CardWithTitle from 'components/CardWithTitle';
import DebounceTextInput from 'components/DebounseTextInput';
import AssignAnotherRMList from './components/AssignAnotherRMList';

const AssignAnotherRM = ({
  id,
  rowSelection,
  onCloseUpdatePopup,
  drawerToggle,
  roleList,
}) => {
  const [searchString, setSearchString] = useState('');
  return (
    <CardWithTitle title={roleList?.length > 0 ? 'BDE' : 'Resource Manager'}>
      <DebounceTextInput
        onInputChange={(val) => setSearchString(val)}
        delay={500} // Set your desired delay in milliseconds
        value={searchString}
        placeholder="Search by Vendor"
        positionRight="20px"
        positionTop="-42px"
      />
      <AssignAnotherRMList
        rowSelection={rowSelection?.map((key) => parseInt(key))}
        id={id}
        searchString={searchString}
        roleList={roleList}
        onCloseUpdatePopup={onCloseUpdatePopup}
        drawerToggle={drawerToggle}
      />
    </CardWithTitle>
  );
};

export default AssignAnotherRM;
